(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["enquiry-prefill"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('[data-enquiry-prefill]');
    if (!el) return;
    var sys = new URLSearchParams(window.location.search).get('system');
    if (!sys) return;
    sys = sys.replace(/[^A-Za-z0-9\-\/]/g, '').slice(0, 30);
    if (!sys) return;
    el.hidden = false;
    var body = document.querySelector('textarea[name="contact[body]"]');
    if (body && !body.value) {
      body.value = 'Milltek system: ' + sys + '\nSection needed: \nCar: \n';
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
